/**
 * Cams API
 * Cams
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface Members { 
    memberId?: string | null;
    userId?: number | null;
    guaranteeRatio?: number | null;
    isPercentage?: boolean | null;
    nameMember?: string | null;
    memberRelationship?: number | null;
    dateOfBirth?: string | null;
    phoneNumber?: string | null;
    countryCode?: string | null;
    address?: string | null;
    guarantorType?: string | null;
    accountName?: string | null;
    accountNo?: string | null;
    blockFund?: boolean | null;
}

